/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { isMobile } from 'react-device-detect'
import * as Utils from '@utils/utils'
import Login from '@views/Login'
import _ from 'lodash'
import { DUPLICATE_REQUEST_CHECK_TIME_LIMIT, SIDE_MENU } from '@constants/index'
import menus from '@views/PrimaryLayout/menu'
import { bettingHistoryStore, routerStore } from '@store/index'
import { useOnMount } from '@utils/reactExt'
import useRootStore from '@store/useRootStore'
import BetSlipBottom from '@views/Matchup/BetSlip/BetSlipBottom'
import { PAGE_TYPE } from '@interface/common'
// icon
import { BettingHistoryIco, HomeIco, MatchupIco, MenuIco } from '@shared/Icon/MenuIcon'
import DiaBubbleImg from '@assets/images/icon/etc_icon/dia-bubble-alert.png'
import DiaBubbleSeasonImg from '@assets/images/bg/season-bg/season-dia-bubble-alert.png'
// css
import { NavRefreshIco } from '@shared/Icon/EtcIcon'
import { NavbarWrap } from './index.style'
import classNames from 'classnames'
import { FROM_VIEW_TYPE } from '@v2/constants/common'

let fetchUserTimeOut = null
let fetchGiftBoxTimeOut = null

interface NavItemStructure {
  key: string
  type: string
  menu: string
  id: string
  value: string
  className: string
  defaultCheck: boolean
  disabled: boolean
  icon: JSX.Element
  onClickQuickMenu: (event) => void
}

const Navbar: React.FC = () => {

  const { globalStore, authStore, joinStore, componentStore, matchupStore, logStore } = useRootStore()
  const { location } = routerStore
  const { giftbox } = componentStore
  const [matchupMenu, setMatchupMenu] = useState('')
  const [bettingHistoryMenu, setBettingHistoryMenu] = useState('')
  const [homeMenu, setHomeMenu] = useState('')
  const { isJoinUrl } = joinStore
  const { isTournamentTrackLoading } = matchupStore

  const hash = location.hash || window.location.hash
  const bettingHistory = _.find(menus, { namespace: SIDE_MENU.BETTING_HISTORY })
  const home = _.find(menus, { namespace: 'home' })

  useOnMount(() => {
    if (Utils.isViewPage(PAGE_TYPE.MATCHUP)) {
      setMatchupMenu('active')
    } else if (hash === `#${bettingHistory.path}`) {
      setBettingHistoryMenu('active')
    } else if (hash === `#${home.path}/`) {
      setHomeMenu('active')
    } else {
      setMatchupMenu('')
    }
  })

  useEffect(() => {
    if (authStore.isSignedIn) {
      refreshGiftBox().catch(console.error)
    }
  }, [authStore.isSignedIn])

  const refreshGiftBox = async () => {
    clearTimeout(fetchGiftBoxTimeOut)
    fetchGiftBoxTimeOut = setTimeout(async () => {
      await componentStore.getGiftBox({})
    }, DUPLICATE_REQUEST_CHECK_TIME_LIMIT)
  }

  const refreshSliderBar = async () => {
    // NOTE : 재화갱신후에 좌측 메뉴 슬라이드 바 시작

    clearTimeout(fetchUserTimeOut)
    fetchUserTimeOut = setTimeout(async () => {
      await authStore.refreshSimpleUserInfo(true)
    }, DUPLICATE_REQUEST_CHECK_TIME_LIMIT)
  }

  const closeMatchFilter = () => {
    globalStore.setVisibleMatchFilterPopup(false)
    matchupStore.resetTournamentFilterList()
  }

  const closeMatchupDetail = () => {
    globalStore.setVisibleMatchupDetailPopup(false)
  }

  // 하단 네비 메뉴 리스트
  const list: NavItemStructure[] = [
    {
      key: 'navbar_home',
      type: 'nav_menu',
      menu: '홈',
      id: 'home',
      value: 'navBarHome',
      className: homeMenu,
      defaultCheck: false,
      disabled: false,
      icon: <HomeIco/>,
      onClickQuickMenu: (event) => {
        logStore.writeButtonLog({ pageId: 'a010', buttonId: '001' }).catch(console.error)
        if (isMobile) {
          event.preventDefault()
          closeMatchFilter()
          closeMatchupDetail()
        }
        globalStore.resetGeneralPopupProperties()
        const hashParameters = Utils.getAttachableHashParameters(true)
        Utils.reloadPage(`home/${hashParameters}`)
        componentStore.getGiftBox({}).catch(console.error)
      },
      // onClickQuickMenu: (e) => {
      //   globalStore.pushDialogOk({
      //     custom: <HomeUpdatePopup/>,
      //     className: 'big-size box-type white-btn',
      //     singlePress: '확인',
      //     callbackCloseDialog: () => {
      //       globalStore.closeDialog()
      //     },
      //     // 뒷배경 클릭 시 닫히도록
      //     callbackCloseDialogBg: () => {
      //       globalStore.closeDialog()
      //     },
      //   })
      // },
    },
    {
      key: 'navbar_matchup',
      type: 'nav_menu',
      menu: '스포츠베팅',
      id: 'matchup',
      value: 'navBarMatchup',
      className: matchupMenu,
      defaultCheck: true,
      disabled: false,
      icon: <MatchupIco/>,
      onClickQuickMenu: (event) => {
        if (!isTournamentTrackLoading) {
          if (isMobile) {
            event.preventDefault()
            closeMatchFilter()
            closeMatchupDetail()
          }
          matchupStore.setPageType(undefined)
          matchupStore.setMatchTabInitializeMajorUniqueId(undefined)
          matchupStore.setMatchTabInitializeSportId(undefined)
          globalStore.resetGeneralPopupProperties()
          const hashParameters = Utils.getAttachableHashParameters(true)
          // 매치업 이동시 루트 (/) 로 이동하면, 뒤로가기 시 루트가 경로에 포함된다.
          Utils.reloadPage(`matchup/cross/${Utils.getInitializeClubId()}${hashParameters}`)
        }
      },
    },
    {
      key: 'navbar_betslip',
      type: 'nav_betslip',
      menu: '',
      id: 'betslip',
      value: 'navBarBetslip',
      className: 'betslip',
      defaultCheck: false,
      disabled: false,
      icon: null,
      onClickQuickMenu: null,
    },
    {
      key: 'navbar_betting_history',
      type: 'nav_menu',
      menu: '베팅내역',
      id: 'bettingHistory',
      value: 'navBarBettingHistory',
      className: bettingHistoryMenu,
      defaultCheck: false,
      disabled: false,
      icon: <BettingHistoryIco/>,
      onClickQuickMenu: (event) => {
        if (isMobile) {
          event.preventDefault()
          closeMatchFilter()
          closeMatchupDetail()
        }

        if (!authStore.isSignedIn) {
          authStore.showLoginPopup(<Login/>)
        } else {
          logStore.writeButtonLog({ pageId: 'c010', buttonId: '001' }).catch(console.error)
          globalStore.resetGeneralPopupProperties()
          bettingHistoryStore.resetSelectedBettingHistory(FROM_VIEW_TYPE.BETTING_HISTORY)
          bettingHistoryStore.setBettingHistoryInitProps({
            onlyMajorClub: false,
            fromViewType: FROM_VIEW_TYPE.BETTING_HISTORY,
          })
          Utils.reloadPage(PAGE_TYPE.BETTING_HISTORY)
          componentStore.getGiftBox({}).catch(console.error)
        }
      },
    },
    {
      key: 'navbar_menu',
      type: 'nav_menu',
      menu: '메뉴',
      id: 'menu',
      value: 'navBarMenu',
      className: '',
      defaultCheck: false,
      disabled: false,
      icon: <MenuIco/>,
      onClickQuickMenu: (event) => {
        if (isJoinUrl) {
          return
        }

        if (!authStore.isSignedIn) {
          if (isMobile) {
            globalStore.setVisibleSideBar(true)
          } else {
            authStore.showLoginPopup(<Login/>)
          }
        } else {
          logStore.writeButtonLog({ pageId: 'd010', buttonId: '001' }).catch(console.error)
          if (isMobile) {
            event.preventDefault()
          }
          event.stopPropagation()

          refreshGiftBox().catch(console.error)
          refreshSliderBar().catch(console.error)

          globalStore.setVisibleSideBar(true)
        }
      },
    },
  ]

  const isAlert = !homeMenu && authStore.isSignedIn && giftbox?.openEnabled
  const giftBoxAlertName = classNames('gift-box-alert-bubble', {
    'alert-none': !isAlert,
  })

  // let giftBoxAlert
  // if (!homeMenu && authStore.isSignedIn && giftbox?.openEnabled ) {
  //   giftBoxAlert = <img src={DiaBubbleImg} alt="무료충전 가능 알림" className={giftBoxAlertName}/>
  // } else {
  //   giftBoxAlert = <Fragment/>
  // }

  return (
    <NavbarWrap className="navbar show">
      <ul className="nav-list">
        {list.map((listItem) =>
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
          <li key={listItem.key} className={listItem.className} onClick={listItem.onClickQuickMenu}>
            {listItem.type === 'nav_menu' &&
              <Fragment>
                {listItem.key === 'navbar_home'&&(
                  <img src={globalStore.isGiftBoxSeasonEffect() ? DiaBubbleSeasonImg : DiaBubbleImg}
                       alt="무료충전 가능 알림" className={giftBoxAlertName}/>
                )}
                <input
                  type="radio"
                  id={listItem.id}
                  name="navbar"
                  value={listItem.value}
                  defaultChecked={listItem.defaultCheck}
                  disabled={listItem.disabled}
                  className="menu-input"
                />
                <label htmlFor={listItem.id} className="menu-item">
                  {listItem.icon}
                  <span className="menu-name">{listItem.menu}</span>
                  {(listItem.id === 'home' || listItem.id === 'matchup' || listItem.id === 'bettingHistory') &&
                    <span className="refresh-ico"><NavRefreshIco/></span>
                  }
                </label>
              </Fragment>
            }
            {listItem.type === 'nav_betslip' &&
              <BetSlipBottom/>
            }
          </li>,
        )}
      </ul>
    </NavbarWrap>
  )
}

export default observer(Navbar)
